/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ConversationNoteOutViewerReaction } from './conversationNoteOutViewerReaction';
import type { ProfileNoteAuthorResponse } from './profileNoteAuthorResponse';

export interface ConversationNoteOut {
  id: string;
  org_id: string;
  conversation_id: string;
  parent_note_id?: string | null;
  author_user_id?: string | null;
  author?: ProfileNoteAuthorResponse | null;
  content: string;
  depth: number;
  like_count?: number;
  dislike_count?: number;
  viewer_reaction?: ConversationNoteOutViewerReaction;
  created_at: string;
  updated_at: string;
  replies?: ConversationNoteOut[];
}
